import { APIDashboardColorTheme, ArdoqId } from '@ardoq/api-types';
import { crudApi, fetchJson, fetchVoid, toRequestOptions, Method } from './api';
import { ApiResponse } from './types';

export const dashboardColorPaletteApi = {
  ...crudApi<APIDashboardColorTheme>('dashboard-color-palette'),
  select: (id: ArdoqId): ApiResponse<APIDashboardColorTheme> => {
    const request = new Request(
      `/api/dashboard-color-palette/${id}/select`,
      toRequestOptions(Method.POST, undefined)
    );
    return fetchJson<APIDashboardColorTheme>(request);
  },
  unselectAll: (): ApiResponse<void> => {
    const request = new Request(
      '/api/dashboard-color-palette/unselect-all',
      toRequestOptions(Method.POST, undefined)
    );
    return fetchVoid(request);
  },
};
